import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "services/authProvider";

export const msalInstance = new PublicClientApplication(msalConfig);
